<mat-dialog-actions class="justify-content-between">
  <h3>{{ (cardOnly ? 'ABHA.CARD_DOWNLOAD' : 'ABHA.TITLE') | translate }}</h3>
  <button mat-icon-button (click)="onCancel()" [disabled]="isBusy" class="d-flex justify-content-center">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>

<mat-dialog-content>
  <div class="abha-panel-body">
    <mat-button-toggle-group *ngIf="!enrolment && !cardOnly" class="m-b-16" [value]="mode" (change)="setMode($event.value)"
      [disabled]="isBusy || isOtpSent">
      <mat-button-toggle value="create">{{ 'ABHA.MODE_CREATE' | translate }}</mat-button-toggle>
      <mat-button-toggle value="verify">{{ 'ABHA.MODE_VERIFY' | translate }}</mat-button-toggle>
      <mat-button-toggle value="find">{{ 'ABHA.MODE_FIND' | translate }}</mat-button-toggle>
      <mat-button-toggle value="scan">{{ 'ABHA.MODE_SCAN' | translate }}</mat-button-toggle>
    </mat-button-toggle-group>

    <form class="abha-create-form" [formGroup]="abhaForm" *ngIf="!enrolment && mode === 'create'">
      <p class="text-muted m-b-16">
        {{ 'ABHA.DESCRIPTION' | translate }}
      </p>

      <div class="abha-create-layout">
        <div class="abha-create-fields">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ABHA.AADHAAR_LABEL' | translate }}</mat-label>
            <input matInput formControlName="aadhaarNumber" maxlength="12" inputmode="numeric" [readonly]="isOtpSent"
              [placeholder]="'ABHA.AADHAAR_PLACEHOLDER' | translate" />
            <mat-error *ngIf="abhaForm.get('aadhaarNumber')?.hasError('required')">
              {{ 'ABHA.AADHAAR_REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="abhaForm.get('aadhaarNumber')?.hasError('pattern')">
              {{ 'ABHA.AADHAAR_PATTERN' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ABHA.MOBILE_LABEL' | translate }}</mat-label>
            <input matInput formControlName="mobile" maxlength="10" inputmode="numeric" [readonly]="isOtpSent"
              [placeholder]="'ABHA.MOBILE_PLACEHOLDER' | translate" />
            <mat-hint>{{ 'ABHA.MOBILE_HINT' | translate }}</mat-hint>
            <mat-error *ngIf="abhaForm.get('mobile')?.hasError('required')">
              {{ 'ABHA.MOBILE_REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="abhaForm.get('mobile')?.hasError('pattern')">
              {{ 'ABHA.MOBILE_PATTERN' | translate }}
            </mat-error>
          </mat-form-field>

          <p class="abha-otp-notice" *ngIf="isOtpSent && otpNotice">{{ otpNotice }}</p>
          <mat-form-field appearance="outline" class="w-100" *ngIf="isOtpSent">
            <mat-label>{{ 'ABHA.OTP_LABEL' | translate }}</mat-label>
            <input matInput formControlName="otp" maxlength="6" inputmode="numeric"
              [placeholder]="'ABHA.OTP_PLACEHOLDER' | translate" />
            <mat-hint>{{ 'ABHA.OTP_HINT' | translate }}</mat-hint>
            <mat-error *ngIf="abhaForm.get('otp')?.hasError('required')">
              {{ 'ABHA.OTP_REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="abhaForm.get('otp')?.hasError('pattern')">
              {{ 'ABHA.OTP_PATTERN' | translate }}
            </mat-error>
          </mat-form-field>
          <app-abha-otp-resend *ngIf="isOtpSent" [isBusy]="isBusy" (resend)="onSendOtp()"></app-abha-otp-resend>
        </div>
        <app-abha-consent [control]="consentControl"></app-abha-consent>
      </div>
    </form>

    <form [formGroup]="verifyForm" *ngIf="!enrolment && mode === 'verify'">
      <p class="text-muted m-b-16">
        {{ (cardOnly ? 'ABHA.CARD_VERIFY_DESCRIPTION' : 'ABHA.VERIFY_DESCRIPTION') | translate }}
      </p>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'ABHA.LOGIN_ID_LABEL' | translate }}</mat-label>
        <input matInput formControlName="loginId" maxlength="60" [readonly]="cardOnly || isOtpSent"
          [placeholder]="'ABHA.LOGIN_ID_PLACEHOLDER' | translate" />
        <mat-error *ngIf="verifyForm.get('loginId')?.hasError('required')">
          {{ 'ABHA.LOGIN_ID_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="verifyForm.get('loginId')?.hasError('pattern')">
          {{ 'ABHA.LOGIN_ID_PATTERN' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="m-b-16" *ngIf="!isOtpSent">
        <label class="d-block m-b-8">{{ 'ABHA.OTP_VIA' | translate }}</label>
        <mat-radio-group formControlName="otpSystem">
          <mat-radio-button value="abdm" class="m-r-16">{{ 'ABHA.OTP_VIA_MOBILE' | translate }}</mat-radio-button>
          <mat-radio-button value="aadhaar">{{ 'ABHA.OTP_VIA_AADHAAR' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <p class="abha-otp-notice" *ngIf="isOtpSent && otpNotice">{{ otpNotice }}</p>
      <mat-form-field appearance="outline" class="w-100" *ngIf="isOtpSent">
        <mat-label>{{ 'ABHA.OTP_LABEL' | translate }}</mat-label>
        <input matInput formControlName="otp" maxlength="6" inputmode="numeric"
          [placeholder]="'ABHA.OTP_PLACEHOLDER' | translate" />
        <mat-hint>{{ 'ABHA.OTP_HINT_LOGIN' | translate }}</mat-hint>
        <mat-error *ngIf="verifyForm.get('otp')?.hasError('required')">
          {{ 'ABHA.OTP_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="verifyForm.get('otp')?.hasError('pattern')">
          {{ 'ABHA.OTP_PATTERN' | translate }}
        </mat-error>
      </mat-form-field>
      <app-abha-otp-resend *ngIf="isOtpSent" [isBusy]="isBusy" (resend)="onSendLoginOtp()"></app-abha-otp-resend>
    </form>

    <app-abha-find *ngIf="!enrolment && mode === 'find'" [patientId]="data?.patientId" [mobile]="data?.mobile"
      (found)="onAbhaFound($event)" (createRequested)="onCreateRequested($event)"
      (stateChanged)="syncFindState()"></app-abha-find>

    <div *ngIf="!enrolment && mode === 'scan'" class="abha-scan">
      <p class="text-muted m-b-16">{{ 'ABHA.SCAN_HINT' | translate }}</p>
      <div class="scanner-container">
        <video #qrVideo class="abha-scan-video" autoplay playsinline muted></video>
        <div class="scanner-overlay">
          <div class="scanner-laser"></div>
          <div class="scanner-frame">
            <div class="corner top-left"></div>
            <div class="corner top-right"></div>
            <div class="corner bottom-left"></div>
            <div class="corner bottom-right"></div>
          </div>
        </div>
      </div>
      <div *ngIf="scanError" class="abha-scan-error m-t-8">
        {{ scanError }}
        <button mat-stroked-button color="primary" class="m-l-8" type="button" (click)="retryScan()">
          {{ 'ABHA.SCAN_RETRY' | translate }}
        </button>
      </div>
    </div>

    <ng-container *ngIf="enrolment && enrolStep">
      <p class="abha-step-created">{{ 'ABHA.STEP_CREATED' | translate: { abhaNumber: enrolment.abhaNumber } }}</p>
      <app-abha-mobile-verify *ngIf="enrolStep === 'mobile'" [txnId]="stepTxnId" [mobile]="abhaForm.get('mobile')?.value"
        (verified)="onMobileVerified($event)" (skipped)="enrolStep = 'address'"></app-abha-mobile-verify>
      <app-abha-address-select *ngIf="enrolStep === 'address'" [txnId]="stepTxnId" [currentAddress]="enrolment.abhaAddress"
        (selected)="onAddressSelected($event)" (kept)="enrolStep = null"></app-abha-address-select>
    </ng-container>

    <div *ngIf="enrolment && !enrolStep" class="abha-success">
      <div class="d-flex align-items-center gap-8 m-b-8">
        <i-tabler name="circle-check" class="icon-20"></i-tabler>
        <strong>{{ (enrolment.isNew ? 'ABHA.CREATED_TITLE' : 'ABHA.EXISTING_TITLE') | translate }}</strong>
      </div>
      <p><strong>{{ 'ABHA.NUMBER' | translate }}</strong> {{ enrolment.abhaNumber }}</p>
      <p><strong>{{ 'ABHA.ADDRESS' | translate }}</strong> {{ enrolment.abhaAddress }}</p>
      <p><strong>{{ 'ABHA.NAME' | translate }}</strong> {{ enrolment.firstName }} {{ enrolment.middleName }} {{ enrolment.lastName }}</p>
      <p *ngIf="enrolment.dateOfBirth"><strong>{{ 'ABHA.DOB' | translate }}</strong> {{ enrolment.dateOfBirth }}</p>
      <p *ngIf="enrolment.mobile"><strong>{{ 'ABHA.MOBILE' | translate }}</strong> {{ enrolment.mobile }}</p>
      <p class="abha-already-linked" *ngIf="enrolment.linkedPatientNumber && !cardOnly">
        {{ 'ABHA.ALREADY_LINKED' | translate: { patientNumber: enrolment.linkedPatientNumber } }}
      </p>
      <p *ngIf="cardOnly && !enrolment.cardToken">{{ 'ABHA.CARD_FAILED' | translate }}</p>
      <app-abha-card *ngIf="enrolment.cardToken" [cardToken]="enrolment.cardToken" [abhaNumber]="enrolment.abhaNumber" [autoDownload]="cardOnly"></app-abha-card>
    </div>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions class="d-flex justify-content-end">
  <div class="row p-r-16">
    <div class="d-flex justify-content-end">
      <button mat-stroked-button class="m-r-5" (click)="onCancel()" [disabled]="isBusy">
        {{ (enrolment && !enrolStep ? 'ABHA.DONE' : 'BUTTON.BTN_CANCEL') | translate }}
      </button>
      <ng-container *ngIf="!enrolment && mode === 'create'">
        <button *ngIf="!isOtpSent" mat-flat-button color="primary" (click)="onSendOtp()" [disabled]="isRequestingOtp">
          {{ (isRequestingOtp ? 'ABHA.SENDING_OTP' : 'ABHA.SEND_OTP') | translate }}
        </button>
        <button *ngIf="isOtpSent" mat-flat-button color="primary" (click)="onVerify()" [disabled]="isEnrolling">
          {{ (isEnrolling ? 'ABHA.VERIFYING' : 'ABHA.VERIFY') | translate }}
        </button>
      </ng-container>
      <ng-container *ngIf="!enrolment && mode === 'verify'">
        <button *ngIf="!isOtpSent" mat-flat-button color="primary" (click)="onSendLoginOtp()" [disabled]="isRequestingOtp">
          {{ (isRequestingOtp ? 'ABHA.SENDING_OTP' : 'ABHA.SEND_OTP') | translate }}
        </button>
        <button *ngIf="isOtpSent" mat-flat-button color="primary" (click)="onVerifyLogin()" [disabled]="isEnrolling">
          {{ (isEnrolling ? 'ABHA.VERIFYING' : 'ABHA.VERIFY_EXISTING') | translate }}
        </button>
      </ng-container>
      <ng-container *ngIf="!enrolment && mode === 'find'">
        <button *ngIf="findIsOtpSent || findHasAccounts" mat-stroked-button
          type="button" class="m-r-8" [disabled]="isBusy" (click)="findComponent?.onSearchAgain()">
          {{ 'ABHA.FIND_SEARCH_AGAIN' | translate }}
        </button>
        <button *ngIf="!findIsOtpSent && !findHasAccounts"
          mat-flat-button color="primary" type="button" [disabled]="isBusy" (click)="findComponent?.onSendOtp()">
          {{ (isBusy ? 'ABHA.SENDING_OTP' : 'ABHA.SEND_OTP') | translate }}
        </button>
        <button *ngIf="findIsOtpSent && !findHasAccounts" mat-flat-button
          color="primary" type="button" [disabled]="isBusy" (click)="findComponent?.onVerifyOtp()">
          {{ (isBusy ? 'ABHA.VERIFYING' : 'ABHA.FIND_VERIFY') | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</mat-dialog-actions>
